import React from "react";

export const thisMonth = () => new Date().toISOString().slice(0, 7);
export const prevMonth = (ym) => { const [y, m] = ym.split("-").map(Number); const t = y * 12 + m - 2; return `${Math.floor(t / 12)}-${String((t % 12) + 1).padStart(2, "0")}`; };
export const MONTHS = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];
export const monthLabel = (ym) => { const [y, m] = ym.split("-").map(Number); return `${MONTHS[m - 1]} ${y}`; };
const SEL = "rounded-xl border border-line bg-white px-3 py-2 text-sm text-slate-800 outline-none focus:border-brand";

export function MonthYearPicker({ value, onChange }) {
  const [y, m] = value.split("-").map(Number);
  const [cy, cm] = thisMonth().split("-").map(Number);
  const years = Array.from({ length: cy - 2024 + 1 }, (_, i) => cy - i);
  const set = (ny, nm) => onChange(`${ny}-${String(ny === cy ? Math.min(nm, cm) : nm).padStart(2, "0")}`);
  const step = (d) => { const t = y * 12 + (m - 1) + d; if (t > cy * 12 + cm - 1) return; onChange(`${Math.floor(t / 12)}-${String((t % 12) + 1).padStart(2, "0")}`); };
  const atMax = y === cy && m === cm;
  return (
    <div data-testid="llm-spend-month">
      <span className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">Periode (UTC)</span>
      <div className="mt-1 flex items-center gap-1.5">
        <button onClick={() => step(-1)} className="btn-soft rounded-xl px-2.5 py-2 text-sm font-bold" aria-label="Bulan sebelumnya" data-testid="llm-spend-prev">‹</button>
        <select value={m} onChange={(e) => set(y, Number(e.target.value))} className={SEL} data-testid="llm-spend-month-select">
          {MONTHS.map((l, i) => <option key={l} value={i + 1} disabled={y === cy && i + 1 > cm}>{l}</option>)}
        </select>
        <select value={y} onChange={(e) => set(Number(e.target.value), m)} className={SEL} data-testid="llm-spend-year-select">
          {years.map((yy) => <option key={yy} value={yy}>{yy}</option>)}
        </select>
        <button onClick={() => step(1)} disabled={atMax} className="btn-soft rounded-xl px-2.5 py-2 text-sm font-bold disabled:opacity-40" aria-label="Bulan berikutnya" data-testid="llm-spend-next">›</button>
      </div>
    </div>
  );
}
